import React, { Fragment, useState } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Badge, Dropdown, notification, Table,
} from 'antd';
import {
  CaretRightFilled, LoadingOutlined, FilePdfOutlined, CaretDownFilled
} from '@ant-design/icons';
import SoActions from '@Actions/sales/soActions';
import H3Text from '@Uilib/h3Text';
import imageDefault from '@Images/icons/imageDefault.png';
import './style.scss';
import Constants, { QUANTITY } from '@Apis/constants';
import { v4 as uuidv4 } from 'uuid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import BatchSelector from './BatchSelector';

const getDataSource = (data) => {
  const finalLines = [];
  if (data) {
    data.map((uf) => {
      const lines = uf.fulfillment_lines;
      const fulfillmentId = uf.fulfillment_id;
      const invoiceId = uf.invoice_id;
      const tenantInfo = uf.tenant_info;
      const shopifyFulfillmentId = uf.shopify_fulfillment_id;
      const sellerInfo = uf.seller_info;
      finalLines.push({
        ...tenantInfo,
        ffId: fulfillmentId,
        invoiceId,
        shopifyFulfillmentId,
        shopify_integration_details: uf.shopify_integration_details,
        shopify_shop_name: uf.shopify_integration_details?.shop_name,
        assigned_shopify_location_id: uf.assigned_shopify_location_id,
      });
      lines.map((line) => finalLines.push({
        ...line,
        seller_info: sellerInfo,
        key: uuidv4(),
        bundle_products: line?.bundle_products?.map((bundleProduct) => ({
          product_sku_info: bundleProduct?.tenant_product_info?.product_sku_info,
          product_sku_name: bundleProduct?.tenant_product_info?.product_sku_info?.product_sku_name,
          product_batches: bundleProduct?.product_batches,
          bundle_quantity: bundleProduct?.quantity,
          uom_info: bundleProduct?.tenant_product_info?.product_sku_info?.uom_info,
        })),
      }));
      // return uf;
    });
  }
  return finalLines;
}

function FulfilledLines(props) {

  const {
    fulfilledFulfillments, cancelFulfillmentLoading, MONEY, soMapping, user, match, getReturnFulfillment, handleDrawerState, cancelFulfillment, callback, getReturnFulfillmentLoading, selectedSO,
  } = props;

  const [state, setState] = useState({
    selectedKey: '',
  });

  const {
    selectedKey,
  } = state;

  const updateState = (newState) => {
    setState((oldState) => ({
      ...oldState,
      ...newState,
    }));
  };

  const fulfilledColumns = [
    {
      title: '',
      width: '60px',
      render: (record) => {

        return ({
          props: { style: { backgroundColor: !record?.fulfillment_id ? '#ABE09835' : 'white' } },
          children: (
            <Fragment>
              {record?.fulfillment_id ? (
                <div style={{ width: '50px', height: '40px' }}>
                  <img style={{ width: '40px', height: '40px', opacity: record?.tenant_product_info?.product_sku_info?.assets?.[0]?.url ? 1 : 0.15 }} src={`${record?.tenant_product_info?.product_sku_info?.assets?.[0]?.url ? record?.tenant_product_info?.product_sku_info?.assets?.[0]?.url : imageDefault}`} />
                  <Badge
                    className="fulfilled-qty__badge"
                    count={QUANTITY(record?.quantity, record?.uom_info?.[0]?.precision)}
                  />
                </div>
              ) : (

                <div className="ff-table__location-wrapper">

                  <div className="ff-table__fg-name">
                    {record?.tenant_name}
                    {' '}
                    <CaretRightFilled />
                  </div>
                  <div className="ff-table__location-wrapper__actions">
                    <div className="filters__buttons">
                      {selectedSO?.shopify_so_object?.fulfillments?.find((item) => item?.id == record?.shopifyFulfillmentId)?.tracking_url && (
                        <div className="tracking__button" style={{ fontSize: '12px' }}>
                          <img src={`http://www.google.com/s2/favicons?domain=${selectedSO?.shopify_so_object?.fulfillments?.find((item) => item?.id == record?.shopifyFulfillmentId)?.tracking_url}`} />
                          &nbsp;
                          <div className="flex-display">
                            <div className="tracking__button-link">
                              <a
                                href={selectedSO?.shopify_so_object?.fulfillments?.find((item) => item?.id == record?.shopifyFulfillmentId)?.tracking_url}
                                target="_blank"
                                rel="noreferrer"
                              >
                                {selectedSO?.shopify_so_object?.fulfillments?.find((item) => item?.id == record?.shopifyFulfillmentId)?.tracking_url}
                              </a>
                            </div>
                            <div
                              onClick={() => {
                                navigator.clipboard.writeText(selectedSO?.shopify_so_object?.fulfillments?.find((item) => item?.id == record?.shopifyFulfillmentId)?.tracking_url);
                                notification.open({
                                  message: 'Link copied!',
                                  placement: 'top',
                                  duration: '2',
                                  type: 'success',
                                });
                              }}
                              className="tracking__button-copy"
                            >
                              <FontAwesomeIcon icon={faCopy} />
                            </div>

                          </div>
                        </div>
                      )}
                      <Dropdown
                        overlay={(
                          <div className="header__custom-dropdown" style={{ width: '215px' }}>
                            <div
                              onClick={() => window.open(`${Constants.Invoice}/download?invoice_id=${record?.invoiceId}`)}
                              style={{ fontWeight: '500' }}
                              className="header__custom-dropdown__option"
                            >
                              <span>
                                <FilePdfOutlined />
                                {' '}
                                Invoice
                              </span>
                            </div>
                            <div
                              onClick={() => window.open(`${Constants.DOWNLOAD_SHIPPING_LABELS}/download?invoice_id=${record?.invoiceId}`)}
                              style={{ fontWeight: '500' }}
                              className="header__custom-dropdown__option"
                            >
                              <span>
                                <FilePdfOutlined />
                                {' '}
                                Shipping Label
                              </span>
                            </div>
                            <div
                              onClick={() => window.open(`${Constants.DOWNLOAD_SHIPPING_LABELS}/download?invoice_id=${record?.invoiceId}&with_price=true`)}
                              style={{ fontWeight: '500' }}
                              className="header__custom-dropdown__option"
                            >
                              <span>
                                <FilePdfOutlined />
                                {' '}
                                Shipping Label with Prices
                              </span>
                            </div>
                            <div
                              className="header__custom-dropdown__option"
                              onClick={() => {

                                const { orderId } = match.params;
                                updateState({ selectedKey: record.shopifyFulfillmentId });
                                getReturnFulfillment(orderId, (fulfillments) => {
                                  const selectedFulfillmentOrder = fulfillments?.data?.filter((item) => item?.shopify_fulfillment_id === record?.shopifyFulfillmentId)?.[0];
                                  if (selectedFulfillmentOrder) {
                                    handleDrawerState(record);
                                  } else {
                                    notification.open({
                                      type: 'error',
                                      message: 'No Return Fulfillments Found',
                                      duration: 4,
                                      placement: 'top',
                                    });
                                  }
                                });
                              }}
                            >
                              <div style={{ fontWeight: '500' }}>{getReturnFulfillmentLoading && record.shopifyFulfillmentId === selectedKey ? <LoadingOutlined /> : 'Create Return'}</div>
                            </div>
                            <div
                              className="header__custom-dropdown__option"
                              onClick={() => {
                                if (!cancelFulfillmentLoading) {
                                  const payload = {
                                    fulfillment_id: record?.ffId,
                                  };
                                  cancelFulfillment(payload, () => {
                                    callback();
                                  });
                                }
                              }}
                            >
                              <div style={{ fontWeight: '500' }}>{cancelFulfillmentLoading ? <LoadingOutlined /> : 'Cancel Fulfillment'}</div>
                            </div>
                          </div>
                        )}
                      >
                        <div className="filter__button" style={{ fontSize: '12px' }}>
                          More
                          <CaretDownFilled />
                        </div>
                      </Dropdown>
                    </div>
                  </div>
                </div>
              )}
            </Fragment>),
        });
      },
      onCell: (item) => {
        if (!item?.fulfillment_id) {
          return { colSpan: 7 };
        }
        return {};
      },
    },
    {
      title: 'PRODUCT',
      render: (item) => {

        const qty = soMapping?.[`${item?.tenant_product_info?.product_sku_info.product_sku_id}`]?.[0].unit_price;
        const total = soMapping?.[`${item?.tenant_product_info?.product_sku_info.product_sku_id}`]?.[0].unit_price * item?.fulfillable_quantity;
        const taxValue = soMapping?.[`${item?.tenant_product_info?.product_sku_info.product_sku_id}`]?.[0]?.tax_info?.tax_value;
        return (
          <div className="fulfilled__product-info__wrapper">
            <div className="fulfilled__product-info">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Link
                  to={`/inventory/product/view/${item?.tenant_product_info?.product_sku_info?.product_sku_id}`}
                  target="_blank"
                >
                  <span style={{ fontSize: '11px' }}>
                    #
                    {item?.tenant_product_info?.product_sku_info?.internal_sku_code}
                  </span>
                </Link>
                {user?.tenant_info?.global_config?.settings?.marketplace_enabled && item?.seller_info?.seller_id && (
                  <div className="fulfilled-qr__status" style={{ backgroundColor: '#f58428' }}>
                    MP
                  </div>
                )}
              </div>
              {item?.tenant_product_info?.product_sku_info?.product_sku_name}
              {user?.tenant_info?.global_config?.settings?.marketplace_enabled && item?.seller_info?.seller_id && (
                <div>
                  <H3Text
                    text={<a href={`/vendors/view/${item?.seller_info?.seller_id}`} target="_blank" rel="noreferrer">{`#${item?.seller_info?.internal_slr_code} - ${item?.seller_info?.seller_name?.toProperCase()}`}</a>}
                    className="fulfilled__field-value"
                  />
                </div>
              )}
              <H3Text text={item.remarks} className="quotation__remarks" />
            </div>
            {!!item?.return_quantity && (
              <div style={{ color: '#ff5454', width: '20%' }}>
                {`${QUANTITY(item?.return_quantity || 0)} ${soMapping?.[`${item?.tenant_product_info?.product_sku_info.product_sku_id}`]?.[0]?.uom_info?.[0]?.uqc?.toProperCase() || ''} Returned`}
              </div>
            )}
            <div className="fulfilled__product-pricing">
              {`${QUANTITY(item?.quantity, item?.uom_info?.[0]?.precision)} ${soMapping?.[`${item?.tenant_product_info?.product_sku_info.product_sku_id}`]?.[0]?.uom_info?.[0]?.uqc?.toProperCase() || ''}`}
              &nbsp;
              x
              &nbsp;
              {MONEY(qty + ((qty * taxValue) / 100))}
            </div>
          </div>
        );
      },
      onCell: (item) => {
        if (!item?.fulfillment_id) {
          return { colSpan: 0 };
        }
        return { colSpan: 5 };
      },
    },
  ];

  const bundleListColumns = [
    {
      title: 'SKU#',
      render: (record) => (
        <Link to={`/inventory/product/view/${record?.product_sku_info?.product_sku_id}`} target="_blank">
          {record?.product_sku_info?.internal_sku_code}
        </Link>
      ),
    },
    {
      title: 'PRODUCT',
      render: (text, record) => (
        <div className="so-table__product-name">
          {record?.product_sku_info?.product_sku_name}
        </div>
      ),
    },
    {
      title: 'QUANTITY',
      dataIndex: 'quantity',
      render: (text, record) => (
        <div className="so-qty-input">
          {`${record?.bundle_quantity} ${record?.product_sku_info?.uom_info?.uqc?.toProperCase()}`}
        </div>
      ),
    },
  ];

  return (
    <Fragment>
      <div className="view-so-ff-table-wrapper">
        <Table
          showHeader
          title={() => `Delivered Items (${getDataSource(fulfilledFulfillments)?.filter((item) => item?.fulfillment_id)?.length || 0})`}
          loading={cancelFulfillmentLoading}
          size="small"
          columns={fulfilledColumns}
          dataSource={getDataSource(fulfilledFulfillments)}
          pagination={false}
          bordered
          scroll={{ x: true }}
          expandable={{
            rowExpandable: (record) => !(['NON_STORABLE', 'SERVICE'].includes(record?.tenant_product_info?.product_sku_info?.product_type?.toUpperCase())) && (record?.tenant_product_info?.product_sku_info?.product_type?.toUpperCase() !== 'BUNDLE' ? record?.product_batches?.length : true),
            expandedRowRender: (record) => (
              <Fragment>
                {record?.bundle_products?.length ? (
                  <div className="inv__bundle-products__wrapper">
                    <Table
                      bordered
                      showHeader
                      size="small"
                      columns={bundleListColumns}
                      dataSource={record.bundle_products}
                      pagination={false}
                      expandable={{
                        rowExpandable: (innerRecord) => innerRecord?.product_sku_name,
                        expandedRowRender: (innerRecord) => (
                          <BatchSelector
                            title="Issued Stock"
                            batches={innerRecord?.product_batches}
                            uomInfo={innerRecord?.uom_info}
                            productUomInfo={innerRecord?.product_sku_info?.uom_info}
                            expiryDays={innerRecord?.product_sku_info?.expiry_days}
                            itemsRow={innerRecord}
                          />
                        ),
                      }}
                      scroll={{ x: true }}
                    />
                  </div>
                ) : (
                  <BatchSelector
                    title="Issued Stock"
                    batches={record?.product_batches}
                    uomInfo={record?.tenant_product_info?.product_sku_info?.uom_info}
                    expiryDays={record?.tenant_product_info?.product_sku_info?.expiry_days}
                  />
                )}
              </Fragment>
            ),
          }}
        />
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ SOReducers, UserReducers }) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  cancelFulfillment: SOReducers.cancelFulfillment,
  cancelFulfillmentLoading: SOReducers.cancelFulfillmentLoading,
  getReturnFulfillmentLoading: SOReducers.getReturnFulfillmentLoading,
  selectedSO: SOReducers.selectedSO,
});

const mapDispatchToProps = (dispatch) => ({
  cancelFulfillment: (payload, callback) => dispatch(SoActions.cancelFulfillment(payload, callback)),
  getReturnFulfillment: (orderId, callback) => dispatch(SoActions.getReturnFulfillment(orderId, callback)),

});

FulfilledLines.propTypes = {
  user: PropTypes.any,
  fulfilledFulfillments: PropTypes.any,
  cancelFulfillment: PropTypes.any,
  callback: PropTypes.any,
  soMapping: PropTypes.any,
  cancelFulfillmentLoading: PropTypes.bool,
  handleDrawerState: PropTypes.any,
  match: PropTypes.func,
  getReturnFulfillment: PropTypes.func,
  getReturnFulfillmentLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FulfilledLines));
